<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-select v-model="queryParams.userId" filterable clearable placeholder="代理商" @change="search">
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" clearable placeholder="ICCID/ICCIDS空格隔开"></el-input>
      </el-form-item>
      <el-form-item  prop="msisdn">
        <el-input v-model="queryParams.msisdn" clearable placeholder="MSISDN/MSISDNS空格隔开"></el-input>
      </el-form-item>
      <el-form-item  prop="cardStatus" >
        <el-select v-model="queryParams.cardStatus" filterable placeholder="运营状态" @change="search" clearable multiple>
            <el-option
              v-for="item in state"
              :key="item.cardStatus"
              :label="item.operationName"
              :value="item.cardStatus"
            ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="showStatus" >
        <el-select v-model="queryParams.showStatus" filterable placeholder="展示状态" @change="search" clearable multiple>
            <el-option
              v-for="item in state"
              :key="item.cardStatus"
              :label="item.operationName"
              :value="item.cardStatus"
            ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="status" >
        <el-select v-model="queryParams.status" placeholder="销卡状态" @change="search" clearable >
            <el-option
              v-for="item in cancelStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="销卡开始日期"
          end-placeholder="销卡结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleBatchImport"  v-hasPermi="['card:cancelCard:batch:import']">批量添加</el-button>
        <el-button type="primary" icon="el-icon-upload" @click="handleImport" class="button-class" v-hasPermi="['card:cancelCard:import']">导入</el-button>
        <el-button type="primary" class="el-icon-download" @click="handleExport" v-hasPermi="['card:cancelCard:export']">导出</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="multiple"  @click="removeCancelCard" class="button-class" v-hasPermi="['card:cancelCard:remove']">移除销卡</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" ref="tableRef" border @sort-change="tableSortChange" @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="selection" align="center" :selectable="cardTypeSelect" width="55px" fixed="left"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" min-width="200px" fixed="left">
        <template slot-scope="{row}">
          <el-link type="success" :underline="false" @click='jumpButton(row.iccid)'>{{row.iccid}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="agentName" label="代理商" align="center" width="260px" :show-overflow-tooltip="true"></el-table-column>
       <el-table-column prop="msisdn" label="MSISDN" align="center" min-width="140px"></el-table-column>
      <el-table-column prop="cardStatus" label="运营状态" align="center" >
          <template slot-scope="{row}">
            <el-tag v-if="row.cardStatus =='已激活'">{{row.cardStatus}}</el-tag>
            <el-tag v-else-if="row.cardStatus =='库存'" type="success">{{row.cardStatus}}</el-tag>
            <el-tag v-else-if="row.cardStatus =='已停机'" type="danger">{{row.cardStatus}}</el-tag>
            <el-tag v-else-if="row.cardStatus =='待激活'" type="info">{{row.cardStatus}}</el-tag>
            <el-tag v-else type="warning">{{row.cardStatus}}</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="showStatus" label="展示状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.showStatus =='已激活'">{{row.showStatus}}</el-tag>
            <el-tag v-else-if="row.showStatus =='库存'" type="success">{{row.showStatus}}</el-tag>
            <el-tag v-else-if="row.showStatus =='已停机'" type="danger">{{row.showStatus}}</el-tag>
            <el-tag v-else-if="row.showStatus =='待激活'" type="info">{{row.showStatus}}</el-tag>
            <el-tag v-else type="warning">{{row.showStatus}}</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="status" label="销卡状态" align="center">
          <template slot-scope="{row}">
            <span v-if="row.status =='1'">上架</span>
            <span v-else>下架</span>
          </template>
      </el-table-column>
      <el-table-column prop="delTime" label="销卡时间" align="center" sortable="custom"  width="160px"></el-table-column>
      <el-table-column prop="lastRechargeTime" label="最后充值时间" align="center" sortable="custom"  width="160px"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"   width="160px"></el-table-column>
      <el-table-column prop="downTime" label="销卡下架时间" align="center"   width="160px"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center"  width="160px"></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <!-- 导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" @close="dialogClose" append-to-body :close-on-click-modal="false">
      <div style="margin-bottom: 8px;">
        <el-form>
          <el-form-item label="销卡类型">
            <el-radio v-model="upload.cancelStatus" label="1" >上架</el-radio>
            <el-radio v-model="upload.cancelStatus" label="0" >下架</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url+ '?cancelStatus=' + upload.cancelStatus"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" style="text-align: center;" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 批量添加弹出框 -->
    <el-dialog title="销卡批量添加" :visible.sync="batchFormOpen" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="batchForm" :model="batchForm" :rules="batchRuleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态" prop="status">
              <el-radio v-model="batchForm.status" label="1" >上架</el-radio>
              <el-radio v-model="batchForm.status" label="0" >下架</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="字段类型" prop="fieldType">
              <el-radio v-model="batchForm.fieldType" label="1" >ICCID</el-radio>
              <el-radio v-model="batchForm.fieldType" label="2" >MSISDN</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="卡号列表" prop="iccids">
              <el-input v-model="batchForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="卡号范围" >
          <el-row>
            <el-col :span="11">
              <el-form-item prop="iccidStart">
                <el-input
                    v-model="batchForm.iccidStart"
                    clearable
                    placeholder="包含开始值"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col style="text-align: center;" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="iccidEnd">
                <el-input
                    v-model="batchForm.iccidEnd"
                    clearable
                    placeholder="包含终止值"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="销卡时间" prop="delTime" v-if="batchForm.status == '1'">
          <el-row>
            <el-col :span="24">
              <el-date-picker v-model="batchForm.delTime" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBatchForm" :loading="submitLoading">确 定</el-button>
        <el-button @click="cancelBatchForm">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {agentList, cancelBatchCards} from "@/api/api.js"; //获取代理商下拉列表
import { cancelCardList , removeCancelCard,exportCancelCard } from "@/api/api.js"; //卡列表
import { getToken } from '@/utils/auth'
export default {
  name:"cancelCard",
  data() {
    return{
      //遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      queryParams:{
        cancelStatus:'1'
      },
      tableData:[],
      dateRange: [],
      folding:false,
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      page: 1,
      pageSize: 10,
      total:0,
      agentList: [],
      // 状态
      state: [
        {
          cardStatus: "1",
          operationName: "库存"
        },
        {
          cardStatus: "2",
          operationName: "待激活"
        },
        {
          cardStatus: "3",
          operationName: "可测试"
        },
        {
          cardStatus: "4",
          operationName: "已激活"
        },
        {
          cardStatus: "5",
          operationName: "已停机"
        },
        {
          cardStatus: "6",
          operationName: "预销户"
        },
        {
          cardStatus: "7",
          operationName: "已销户"
        },
        {
          cardStatus: "8",
          operationName: "停机保号"
        },
        {
          cardStatus: "9",
          operationName: "已补卡"
        }
      ],
      cancelStatus:[
        {
          value: '1',
          label: '已上架'
        }, {
          value: '0',
          label: '已下架'
        }
      ],
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        //上架1  下架0
        cancelStatus:"1",
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: getToken()},
        // 上传的地址
        url: "/cms/cancelCard/import",
      },
      dialog:false,
      batchFormOpen:false,
      submitLoading:false,
      batchForm:{
        status:"1",
        delTime:undefined,
        iccidEnd:undefined,
        iccidStart:undefined,
        iccids:undefined,
        fieldType:undefined
      },
      batchRuleForm: {
        status: [
          { required: true, message: "状态不能为空", trigger: "blur" },
        ],
        fieldType: [
          { required: true, message: "字段类型不能为空", trigger: "blur" },
        ],
        delTime: [
          { required: true, message: "销卡时间不能为空", trigger: "blur" },
        ],
      }
    }
  },
  methods: {
    handleBatchImport(){
      this.batchFormOpen = true;
    },
    cancelBatchForm(){
      this.resetForm('batchForm');
      this.batchFormOpen = false;
    },
    submitBatchForm(){
      let { iccids } = this.batchForm;
      let params = {
        ...this.batchForm,
        iccids:iccids ? iccids.split("\n") : []
      };
      this.$refs["batchForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          cancelBatchCards(params).then(res => {
            this.$notify.info({
              title: "提示",
              message: "销卡批量操作已提交，请在任务中心查看进度",
              duration: 1000,
              offset:30
            });
            this.submitLoading = false;
            this.cancelBatchForm();
            this.resetQuery();
          }).catch(() => {
            this.submitLoading = false;
          })
        }
      });
    },
    //判断是否可以被选中
    cardTypeSelect(row,index){
        return row.cardStatus != '已销户';
    },
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize
      }

      this.loading = true;
      cancelCardList(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }else{
          this.$message.error("加载时间过长，请重试！");
          this.loading = false;
        }
      })
    },
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      if(val.prop == 'lastRechargeTime'){
        this.sortName = 'lastRechargeTime'
      }
      if(val.prop == 'delTime'){
        this.sortName = 'delTime'
      }
      this.initData()
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.sortOrder = '';
      this.sortName = '';
      this.$refs.tableRef.clearSort();
      this.resetForm("queryForm");
      this.queryParams = {cancelStatus:'1'};
      this.search();
    },
    
    // 导出
    handleExport(){
      let params = {
        ...this.addDateRange(this.queryParams, this.dateRange),
      }
      exportCancelCard(params).then(res=>{
        if (res.data.code == 200) {
          this.$notify({
            title: "提示",
            message: "已提交导出，请在任务中心查看进度",
            type: "success",
            offset:30
          });
          setTimeout(()=>{
            this.$router.push({ path: `/taskCenter/missionList`});
          },1000)
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    handleImport() {
      this.upload.title = "销卡卡导入";
      this.upload.open = true;
    },
    /** 下载模板操作 */
    importTemplate() {
      this.download('/cardProduct/importTemplate', {
      }, `transferProduct_template_${new Date().getTime()}.xlsx`)
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.search();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        this.agentList = res.data.data;
      });
    },
    // 多选单选的值
    handleSelectionChange(selection){
      this.ids = selection.map(item => item.id);
      this.single = selection.length!=1;
      this.multiple = !selection.length;
    },
    removeCancelCard(row){
        let ids = row.id;
        if(!!ids){
            ids = [row.id];
        }
        const cardIds = ids || this.ids;
        this.$confirm('是否确认将这些数据移除销卡？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids:cardIds
          };
          removeCancelCard(params).then(res=>{
              let msg = res.data.message;
              if(res.data.code==200){
                  this.$message({
                            type: 'success',
                            message: '移除成功'
                          });
                  this.initData()
              }else{
                this.$message({
                            type: 'waring',
                            message: msg
                          });
              }
          });
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除'
          });          
        });
       
    },
    
    // 关闭弹窗
    dialogClose(){
      this.dialog = false;
      this.initData();
    },
    jumpButton(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
  },
  mounted() {

  },
  created() {
    this.queryAgentList();
    this.initData()
  }
};
</script>
<style scoped lang="less">
</style>


